/**
 * @returns Money or an empty object if price is undefined.
 */

export const getPlanPrice = plan => {
  var _plan$pricing;
  return (plan == null || (_plan$pricing = plan.pricing) == null ? void 0 : _plan$pricing.price) ?? {};
};
//# sourceMappingURL=get-plan-price.js.map